import { useDispatch, useSelector } from "react-redux";
import useSurvey from "../../surveys/hooks/useSurvey";
import { useEffect, useRef, useState } from "react";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";
import styles from "../styles/styles.module.css";
import { Input } from "antd";



const SurveysHomeUI = () => {
  const surveyInfo = useSelector((state) => state.surveyInfo);
  const { saveInitialSurveyInfo, getSurveyInfo } = useSurvey();
  const [title, setTitle] = useState(undefined);
  const [description, setDescription] = useState(undefined);
  const refTime = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (surveyInfo) {
      setTitle(surveyInfo.title);
      setDescription(surveyInfo.description);
    }
  }, [surveyInfo]);

  const saveInitialSurveyInfoHandler = async (data) => {
    if (refTime.current) {
      clearTimeout(refTime.current);
    }
    refTime.current = setTimeout(async () => {
      dispatch(setLoadingSurvey(true));
      await saveInitialSurveyInfo(data);
      await getSurveyInfo(surveyInfo.id);
      dispatch(setLoadingSurvey(false));
    }, 500);
  };

  const handleFieldChange = async (field, value) => {
    if (!surveyInfo) {
      return alert("Error: No existe una encuesta disponible.");
    }

    if (field === "title") setTitle(value);
    else setDescription(value);

    saveInitialSurveyInfoHandler({
      id_survey: surveyInfo.id,
      survey_name: surveyInfo.survey_name,
      title: field === "title" ? value : title,
      description: field === "description" ? value : description,
    });
  };

  return (
    <div className={styles["home-container"]}>
      <div style={{ margin: "0 auto" }}>
        {/*<CustomUpload
          customRequest={uploadHomeImage}
          beforeUpload={validateImage}
          defaultFileList={
            surveyInfo?.path_image_survey
              ? [
                  {
                    uid: surveyInfo?.path_image_survey,
                    name: surveyInfo?.path_image_survey,
                    status: "done",
                    url: surveyInfo?.path_image_survey,
                  },
                ]
              : []
          }
        >
          <div style={{ padding: 16 }}>
            {!surveyInfo?.path_image_survey
              ? "Subir Imagen"
              : "Actualizar Imagen"}
          </div>
        </CustomUpload>*/}
      </div>

      <div className={`${styles["form-item"]} ${styles["form-item--title"]}`}>
        <span className={styles["form-item-label"]}>Título</span>
        <Input.TextArea
          value={title}
          autoSize
          bordered={false}
          onChange={(e) => handleFieldChange("title", e.target.value)}
        />
      </div>

      <div
        className={`${styles["form-item"]} ${styles["form-item--description"]}`}
      >
        <span className={styles["form-item-label"]}>Descripción</span>
        <Input.TextArea
          value={description}
          autoSize
          bordered={false}
          onChange={(e) => handleFieldChange("description", e.target.value)}
        />
      </div>
    </div>
  );
};

export default SurveysHomeUI;
